import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const tradeoffs = ['Spread the team thinner', 'Accept bigger blind spots'];

const growthCards = [
  {
    stat: 'Every departure',
    detail: 'Takes recurring revenue with it.',
  },
  {
    stat: "Next month's ARR",
    detail: 'Has to replace what you just lost before the business grows at all.',
  },
  {
    stat: 'Limited CS capacity',
    detail: "Spent trying to work out which accounts need attention and which don't.",
  },
];

export default function GrowthTaxSection() {
  return (
    <section className="py-24 px-6 bg-dark-gray-b border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="max-w-3xl mb-14">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            Churn doesn&apos;t just cost you revenue. It makes growth harder to keep.
          </h2>
        </LandingReveal>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {growthCards.map((item, index) => (
            <LandingReveal
              key={item.stat}
              delayClass={index === 0 ? 'landing-delay-1' : index === 1 ? 'landing-delay-2' : 'landing-delay-3'}
            >
              <div className="landing-card p-6 h-full">
                <p className="text-accent text-sm font-semibold uppercase tracking-wider mb-3">{item.stat}</p>
                <p className="text-secondary text-lg leading-relaxed">{item.detail}</p>
              </div>
            </LandingReveal>
          ))}
        </div>

        <LandingReveal>
          <div
            className="landing-card p-8 md:p-10 border-primary"
            style={{ backgroundColor: 'rgba(0, 185, 255, 0.04)' }}
          >
            <p className="landing-prose mb-6">As the customer base grows, the trade-off gets worse:</p>
            <ul className="space-y-4">
              {tradeoffs.map((item) => (
                <li key={item} className="flex items-start gap-3 text-lg text-primary">
                  <span className="text-orange font-bold mt-0.5">×</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </LandingReveal>
      </div>
    </section>
  );
}
